const rowItemClass = '.accordion__row--relative';
const readMoreTriggerClass = '.accordion__trigger';
const descriptionItemClass = '.accordion__info';
// const descriptionLinkItemClass = '.accordion__info-link';

window.addEventListener('load', () => {
  const rows = document.querySelectorAll(rowItemClass);
  rows.forEach((row) => {
    const readMoreBtn = row.querySelector(readMoreTriggerClass);
    const textContainer = row.querySelector(descriptionItemClass);
    const image = row.querySelector('.accordion__image');

    if (image) {
      row.addEventListener('mouseenter', () => {
        image.classList.add('visible');
      });

      row.addEventListener('mouseleave', () => {
        image.classList.remove('visible');
      });
    }

    const clickHandler = () => {
      if (!readMoreBtn.classList.contains('opened')) {
        readMoreBtn.classList.add('opened');
        textContainer.classList.add('opened');
      } else {
        readMoreBtn.classList.remove('opened');
        textContainer.classList.remove('opened');
      }
    };

    const handleWindowResize = () => {
      if (!readMoreBtn && !textContainer) {
        return;
      }

      if (window.innerWidth < 992) {
        row.removeEventListener('click', clickHandler);
        row.addEventListener('click', clickHandler);
        readMoreBtn.classList.remove('d-none');
      } else {
        row.removeEventListener('click', clickHandler);
        readMoreBtn.removeEventListener('click', clickHandler);
        readMoreBtn.addEventListener('click', clickHandler);

        if (textContainer && textContainer.scrollHeight <= 40) {
          readMoreBtn.classList.add('d-none');
        } else {
          readMoreBtn.classList.remove('d-none');
        }
      }
    };

    window.addEventListener('resize', handleWindowResize);

    handleWindowResize();
  });
});
